import { useEffect, useState } from 'react';
import { useContent } from 'src/contexts/ContentContext/Content';
import { ContentId } from 'src/utils/constants/contentId';

import { ChartHeaderInput } from '../ChartHeader';
import { SaleChartData, useDataInsights } from '../DataInsightsContext';
import { DataLineChart } from '../LineChart/DataLineChart';
import { TimePeriodSelector } from '../TimePeriodSelector';

export const SalesChart = ({
  data,
  renderHeader,
}: {
  data: SaleChartData[] | null;
  renderHeader: (input: ChartHeaderInput) => JSX.Element;
}) => {
  const soldTicketsText = useContent(ContentId.SoldTickets);
  const { paddedChartData, isScrolling, isLoading } = useDataInsights();

  const [ticketsSold, setTicketsSold] = useState<number | null>(
    data && data.length > 0 ? data[data.length - 1].totalQuantity : null
  );

  useEffect(() => {
    if (data && data.length > 0) {
      setTicketsSold(data[data.length - 1].totalQuantity);
    }
  }, [data]);

  return (
    <>
      {renderHeader({
        chartHeaderPostfix: ` ${soldTicketsText}`,
        decimals: 0,
        value: ticketsSold,
        isScrolling,
      })}
      <DataLineChart
        data={data}
        paddedData={paddedChartData}
        setValue={setTicketsSold}
        valueKey="totalQuantity"
        renderTooltipValue={(item) => {
          return `${item} ${soldTicketsText}`;
        }}
      />
      <TimePeriodSelector />
    </>
  );
};
